var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357143,
    y: 0.357143,
    width: 19.2857,
    height: 19.2857,
    rx: 9.64286,
    stroke: "#38CB89",
    strokeWidth: 0.714286
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27192_50155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8575 9.04618L10.9528 7.14142M5.47656 14.5224L7.08817 14.3433C7.28507 14.3214 7.38352 14.3105 7.47554 14.2807C7.55718 14.2543 7.63487 14.2169 7.70651 14.1697C7.78725 14.1164 7.8573 14.0464 7.99738 13.9063L14.2861 7.61761C14.8121 7.09163 14.8121 6.23883 14.2861 5.71285C13.7601 5.18686 12.9073 5.18686 12.3813 5.71285L6.09262 12.0016C5.95254 12.1416 5.88249 12.2117 5.82925 12.2924C5.78201 12.3641 5.74466 12.4418 5.71824 12.5234C5.68845 12.6154 5.67751 12.7139 5.65563 12.9108L5.47656 14.5224Z",
    stroke: "#38CB89",
    strokeWidth: 0.952381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27192_50155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4286,
    height: 11.4286,
    fill: "white",
    transform: "translate(4.28906 4.28516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.0972e2b5859ae6aecfc5e03d1594d94b.svg";
export { ForwardRef as ReactComponent };